import { render, staticRenderFns } from "./Safetyworks.vue?vue&type=template&id=49a3ab18&"
import script from "./Safetyworks.vue?vue&type=script&lang=js&"
export * from "./Safetyworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports